export const validatePassword = (password) => {
    const minLength = 9;
    const maxLength = 15;
    const numberRegex = /[0-9]/;
    const capitalLetterRegex = /[A-Z]/;
    const lowerCaseLetterRegex = /[a-z]/;
    const specialCharRegex = /[~!@()#$%^*:;]/;
    const allowedCharRegex = /^[A-Za-z\d~!@()#$%^*:;]+$/;

    if (password.length === 0) {
        return 'Please Input Password.';
    }

    if (password.length < minLength || password.length > maxLength) {
        return `Password must be between ${minLength} and ${maxLength} characters long. `;
    }

    if (!allowedCharRegex.test(password)) {
        return 'Password contains invalid characters.';
    }

    if (!numberRegex.test(password)) {
        return 'Password must contain at least one number. ';
    }
    if (!capitalLetterRegex.test(password)) {
        return 'Password must contain at least one capital letter. ';
    }
    if (!lowerCaseLetterRegex.test(password)) {
        return 'Password must contain at least one lower case letter. ';
    }
    if (!specialCharRegex.test(password)) {
        return 'Password must contain at least one special character.';
    }

    return '';
};

export const validatePasswordTH = (password) => {
    const minLength = 9;
    const maxLength = 15;
    const numberRegex = /[0-9]/;
    const capitalLetterRegex = /[A-Z]/;
    const lowerCaseLetterRegex = /[a-z]/;
    const specialCharRegex = /[~!@()#$%^*:;]/;
    const allowedCharRegex = /^[A-Za-z\d~!@()#$%^*:;]+$/;

    if (password.length === 0) {
        return 'กรุณากรอกรหัสผ่าน';
    }

    if (password.length < minLength || password.length > maxLength) {
        return `ต้องมีความยาวรหัสตั้งแต่ ${minLength} ถึง ${maxLength} ตัวอักษร`;
    }

    if (!allowedCharRegex.test(password)) {
        return 'ต้องประกอบด้วยตัวอักษรและอักขระที่อนุญาตเท่านั้น';
    }

    if (!numberRegex.test(password)) {
        return 'ต้องประกอบด้วยตัวเลขอย่างน้อยหนึ่งตัว';
    }
    if (!capitalLetterRegex.test(password)) {
        return 'ต้องประกอบด้วยตัวอักษรพิมพ์ใหญ่อย่างน้อยหนึ่งตัวอักษร';
    }
    if (!lowerCaseLetterRegex.test(password)) {
        return 'ต้องประกอบด้วยตัวอักษรพิมพ์เล็กอย่างน้อยหนึ่งตัวอักษร';
    }
    if (!specialCharRegex.test(password)) {
        return 'ต้องประกอบด้วยตัวอักษรพิเศษอย่างน้อยหนึ่งตัวอักษร เช่น (e.g., !,@,#,$,*,;,&). ';
    }

    return '';
};

export const validateNameEN = (value) => {
    const allowedRegex = /^[A-Za-z0-9\s]+$/;
    const hasLetterRegex = /[A-Za-z]/;

    if (!value || value.trim().length === 0) {
        return 'Please Input  at least one English letter.';
    }

    if (!allowedRegex.test(value)) {
        return 'Only English letters, numbers, and spaces are allowed.';
    }

    if (!hasLetterRegex.test(value)) {
        return 'Name must contain at least one English letter.';
    }

    return '';
};

export const validateNameENTH = (value) => {
    const allowedRegex = /^[A-Za-z0-9\s]+$/;
    const hasLetterRegex = /[A-Za-z]/;

    if (!value || value.trim().length === 0) {
        return 'กรุณากรอกตัวอักษรภาษาอังกฤษอย่างน้อยหนึ่งตัว';
    }

    if (!allowedRegex.test(value)) {
        return 'กรอกได้เฉพาะภาษาอังกฤษ ตัวเลข และช่องว่างเท่านั้น';
    }

    if (!hasLetterRegex.test(value)) {
        return 'ต้องมีตัวอักษรภาษาอังกฤษอย่างน้อย 1 ตัว';
    }

    return '';
};